import {merge} from 'ramda';

export const CANCEL_POLICIES = {
  nr:
    '_%esta reserva es no reembolsable, por lo tanto no se puede cancelar o modificar. Para poder hacer la reserva es necesaria una tarjeta de crédito. Una vez hecha la reserva el hotel cargará la cantidad correspondiente en dicha tarjeta.%_',
  ref_percentage:
    '_%cancelación sin penalización hasta {anticipation} {time_unit} antes de la entrada del cliente, después de este periodo o caso de no-show el hotel podrá facturar el {value}% de la reserva.%_',
  ref_days:
    '_%cancelación sin penalización hasta {anticipation} {time_unit} antes de la entrada del cliente, después de este periodo o caso de no-show el hotel podrá facturar {nights} {nights_text} de la reserva.%_',
  // Mantenemos estas traducciones comentadas mientras siga revertida la tarea #20291
  ref_percentage_group:
    //'_%cancelación sin penalización hasta {anticipation} {time_unit} antes de la entrada del cliente, después de este periodo o caso de no-show el hotel podrá facturar el {value}% de la reserva.%_',
      '_%cancelación gratuita hasta las {hours} del {date}, si cancelas más tarde o en caso de no show el hotel podrá factura el {value}% de la reserva.%_',
  ref_days_group:
    //'_%cancelación sin penalización hasta {anticipation} {time_unit} antes de la entrada del cliente, después de este periodo o caso de no-show el hotel podrá facturar {nights} {nights_text} de la reserva.%_',
    '_%cancelación gratuita hasta las {hours} del {date}, si cancelas más tarde o en caso de no show el hotel podrá facturar {nights} {nights_text} de la reserva.%_',
     
  ref_percentage_same_day:  
  '_%cancelación gratuita hasta las {hours} del día del check-in, después de este periodo o caso de no-show el hotel podrá facturar el {value}% de la reserva.%_',
 ref_days_same_day:
  '_%cancelación gratuita hasta las {hours} del día del check-in, después de este periodo o caso de no-show el hotel podrá facturar {nights} {nights_text} de la reserva.%_',

  past_release_ref_percentage:
    '_%en caso de cancelación o de no show el hotel facturará un {value}% de la reserva en concepto de gastos.%_',
  past_release_ref_days:
    '_%en caso de cancelación o de no show el hotel facturará {nights} {nights_text} en concepto de gastos.%_',
  refundable_penalty_checkin_percentage:
    '_%cancelación sin penalización hasta las {time} horas del día de checkin, después de este periodo o caso de no-show el hotel podrá facturar el {value}% de la reserva.%_',
  flexible_rate:
    '_%tarifa flexible con cambio de fechas permitido. Garantiza tu reserva con el pago ahora y si lo deseas, podrás modificar tu fecha de llegada hasta {daysBefore} días antes. Esta reserva es no reembolsable.%_',
  refundable_free :
    '_%cancelación gratis! Puedes cancelar gratis en cualquier momento.%_'
};


export const CANCEL_POLICIES_MYFLEXROON = {
  nr: '_%consulta los motivos de anulación que garantizan la devolución del importe prepagado. Ver más detalles en las condiciones de tarifa.%_'
};

export const GET_TEXT_CANCEL_POLICIES = (pms) => {
  switch (pms) {
    case 'FlexMyRoom':
      return merge(CANCEL_POLICIES, CANCEL_POLICIES_MYFLEXROON);

    default:
      return CANCEL_POLICIES;
  }
};


export const TIME_UNITS = {
  hours: '_%horas%_',
  days: '_%días%_',
  weeks: '_%semanas%_'
};
